var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "buliding",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91218",
    "data-name": "Path 91218",
    d: "M40.435,22.881H2.065a.815.815,0,1,1,0-1.631H40.435a.815.815,0,1,1,0,1.631Z",
    transform: "translate(-2 16.369)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91219",
    "data-name": "Path 91219",
    d: "M10.739,1.25H29.924c5.474,0,8.489,3.015,8.489,8.489v30.7a.815.815,0,0,1-.815.815H3.065a.815.815,0,0,1-.815-.815V9.739C2.25,4.265,5.265,1.25,10.739,1.25ZM36.782,39.619V9.739A7.3,7.3,0,0,0,35.3,4.845c-1.126-1.3-2.935-1.965-5.378-1.965H10.739c-2.443,0-4.252.661-5.378,1.965a7.3,7.3,0,0,0-1.48,4.894v29.88Z",
    transform: "translate(-1.082 -2)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91220",
    "data-name": "Path 91220",
    d: "M12.821,17.381H7.065a.815.815,0,1,1,0-1.631h5.755a.815.815,0,1,1,0,1.631Z",
    transform: "translate(2.592 11.318)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91221",
    "data-name": "Path 91221",
    d: "M19.821,17.381H14.065a.815.815,0,1,1,0-1.631h5.755a.815.815,0,1,1,0,1.631Z",
    transform: "translate(9.022 11.318)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91222",
    "data-name": "Path 91222",
    d: "M12.821,12.881H7.065a.815.815,0,0,1,0-1.631h5.755a.815.815,0,1,1,0,1.631Z",
    transform: "translate(2.592 7.185)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91223",
    "data-name": "Path 91223",
    d: "M19.821,12.881H14.065a.815.815,0,0,1,0-1.631h5.755a.815.815,0,0,1,0,1.631Z",
    transform: "translate(9.022 7.185)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91224",
    "data-name": "Path 91224",
    d: "M12.821,8.381H7.065a.815.815,0,1,1,0-1.631h5.755a.815.815,0,1,1,0,1.631Z",
    transform: "translate(2.592 3.052)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91225",
    "data-name": "Path 91225",
    d: "M19.821,8.381H14.065a.815.815,0,1,1,0-1.631h5.755a.815.815,0,1,1,0,1.631Z",
    transform: "translate(9.022 3.052)",
    fill: "#09143a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondo);
export default __webpack_public_path__ + "static/media/Condo.27f97c3d10e6860972216a59ad711c3f.svg";
export { ForwardRef as ReactComponent };